import React from 'react';
import { Button, Toggle, Tooltip, Whisper } from 'rsuite';
import infoIcon from '../../../../../../assets/icons/icon_info_gray.svg';
import shoppingBrasil from '../../../../../../assets/shoppingBrasil/powered_by_shopping_brasil.svg';
import styles from './AdsFilter.module.scss';
import { ADS_TOOLTIP } from '../../data';

type AdsFilterProps = {
  checked: boolean;
  onChange: (value: boolean) => void;
  onClick: () => void;
};

export const AdsFilter = ({ checked, onChange, onClick }: AdsFilterProps) => {
  return (
    <div className={styles['ad-container']}>
      <span className={styles['toggle-title']}>ANÚNCIOS</span>
      <div className={styles['toggle-container']}>
        <div className={styles.ad}>
          <Toggle size="sm" checked={checked} id="add-toggle" onChange={onChange} style={{ marginRight: '5px' }} />
          <span>Somente produtos com anúncio</span>
          <span className={styles['toggle-info-icon']}>
            <Whisper placement="bottom" trigger="hover" speaker={<Tooltip>{ADS_TOOLTIP}</Tooltip>}>
              <img src={infoIcon} alt="" />
            </Whisper>
          </span>
        </div>
      </div>
      <Button appearance="subtle" className={styles['shopping-brasil-btn']} onClick={onClick}>
        <img src={shoppingBrasil} alt="" />
      </Button>
    </div>
  );
};
